import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CardMedia from "@mui/material/CardMedia";
import DtvTooltip from "@directv-digital/dds.ui.dtv-tooltip";
import { CheckIcon, ErrorIcon } from "@directv-digital/fusion.atoms.icons";
import { colorPalette } from "@directv-digital/dds.ui.dtv-theme";
import FusionTheme from "@directv-digital/fusion.themes.fusion";

const fusionPalette = FusionTheme.fusion.palette;
const BRAND_COLORS = {
  gradientStart: colorPalette.newOzone.main,       // #006DFF
  gradientEnd: colorPalette.turquioseAccent.main,  // #09F0FF
  includedGreen: colorPalette.confirmationText.main, // #1E815D
  notIncludedRed: fusionPalette.red500 as string  // #E35A4D
} as const;
const GRADIENT_BORDER = `linear-gradient(to right, ${BRAND_COLORS.gradientStart}, ${BRAND_COLORS.gradientEnd}) 1`;
const GRADIENT_BORDER_VERTICAL = `linear-gradient(to bottom, ${BRAND_COLORS.gradientStart}, ${BRAND_COLORS.gradientEnd}) 1`;

export interface DtvCompetitorTableProps {
    id?: string;
    enableColumnBgColor?: any;
    isComparisonTable?: boolean;
    headerSectionBgColor?: any;
    features?: any[];
    products?: any[];
    header?: any[];
    section1ColBgColor?: any;
    section2ColBgColor?: any;
    section3ColBgColor?: any;
    bodyTextAlign?: any;
    headerTextAlign?: any;
    sectionBgColor?: any;
    tableHeadFontSize?: any;
    tableBodyFontSize?: any;
    headerFontSize?: any;
    tableBodyRowHeight?: any;
    mobileTableBodyRowHeight?: any;
}

export const DtvCompetitorTable = (props: DtvCompetitorTableProps) => {
  try {
    const {
      id: _id,
      enableColumnBgColor,
      isComparisonTable = true,
      headerSectionBgColor,
      section1ColBgColor,
      section2ColBgColor,
      section3ColBgColor,
      features,
      products,
      header,
      sectionBgColor,
      bodyTextAlign,
      headerTextAlign,
      tableHeadFontSize,
      tableBodyFontSize,
      headerFontSize,
      tableBodyRowHeight,
      mobileTableBodyRowHeight
    } = props;
    const directvProducts = products?.filter(p => p.category === 'directv');
    const competitorProducts = products?.filter(p => p.category === 'competitors');
    const directvHeader = header?.find(h => h.category === 'directv');
    const getFontSize = (textType, type) => {
      // eslint-disable-next-line eqeqeq
      if (textType == "title") {
        // eslint-disable-next-line eqeqeq
        if (type == "header" || type == "mheader") {
          return headerFontSize?.title ? headerFontSize?.title : {
            md: "20px !important",
            sm: "16px !important",
            xs: "16px !important"
          };
        // eslint-disable-next-line eqeqeq
        } else if (type == "thead") {
          return tableHeadFontSize?.title ? tableHeadFontSize?.title : "16px !important";
        }
        return tableBodyFontSize?.title ? tableBodyFontSize?.title : "14px !important";
      // eslint-disable-next-line eqeqeq
      } else if (textType == "description") {
        // eslint-disable-next-line eqeqeq
        if (type == "header" || type == "mheader") {
          return headerFontSize?.description ? headerFontSize?.description : {
            md: "20px !important",
            sm: "16px !important",
            xs: "16px !important"
          };
        // eslint-disable-next-line eqeqeq
        } else if (type == "thead") {
          return tableHeadFontSize?.description ? tableHeadFontSize?.description : {
            md: "14px !important",
            sm: "12px !important",
            xs: "12px !important"
          }
        }
        return tableBodyFontSize?.description ? tableBodyFontSize?.description : {
          md: "14px !important",
          sm: "16px !important",
          xs: "16px !important"
        };
      // eslint-disable-next-line eqeqeq
      } else if (textType == "titleDescription") {
        // eslint-disable-next-line eqeqeq
        if (type == "thead") {
          return tableHeadFontSize?.titleDescription ? tableHeadFontSize?.titleDescription : {
            md: "14px !important",
            sm: "14px !important",
            xs: "14px !important"
          }
        }
        return tableBodyFontSize?.titleDescription ? tableBodyFontSize?.titleDescription : {
          md: "14px !important",
          sm: "14px !important",
          xs: "14px !important"
        };
      // eslint-disable-next-line eqeqeq
      } else if (textType == "titleCaption") {
        // eslint-disable-next-line eqeqeq
        if (type == "thead") {
          return tableHeadFontSize?.titleCaption ? tableHeadFontSize?.titleCaption : {
            md: "12px !important",
            sm: "12px !important",
            xs: "12px !important"
          }
        }
        return tableBodyFontSize?.titleCaption ? tableBodyFontSize?.titleCaption : {
          md: "12px !important",
          sm: "12px !important",
          xs: "12px !important"
        };
      }
    }
    const getContent = (cell: any, key?: any, type?: any, index?: any, section?: any, opts?: { imgContainerSx?: any; isDirectv?: boolean; titleFontWeight?: string; hideImg?: boolean }) => {
      const { imgContainerSx, isDirectv, titleFontWeight, hideImg } = opts ?? {};
      return (
                <>
                    {/* Generated by Copilot- Start - 2026-04-21 01:00:40 */}
                    {cell?.availability ? (
                        (() => {
                            let imgMargin = "auto";
                            // eslint-disable-next-line eqeqeq
                            if (type == "thead" && headerTextAlign?.toLowerCase() != "center") {
 imgMargin = "0px";
}
                            // eslint-disable-next-line eqeqeq
                            if (type == "tbody" && bodyTextAlign?.toLowerCase() != "center") {
 imgMargin = "0px";
}
                            const iconSx = {
                                display: "block",
                                margin: imgMargin,
                                width: "36px",
                                height: "36px",
                                // eslint-disable-next-line eqeqeq
                                ...(type == "tbody" && key != "features1" ? { paddingTop: "10px" } : {})
                            };
                            if (cell.availability === "included") {
                                return (
                                    <span aria-label="Included" role="img" style={{
 display: "block",
margin: imgMargin
}}>
                                        <CheckIcon desc="Included" fill={isDirectv ? BRAND_COLORS.includedGreen : "#000000DE"} sx={iconSx} title="Included" />
                                    </span>
                                );
                            }
                            if (cell.availability === "not_included") {
                                return (
                                    <span aria-label="Not Included" role="img" style={{
 display: "block",
margin: imgMargin
}}>
                                        <ErrorIcon desc="Not Included" fill={BRAND_COLORS.notIncludedRed} sx={iconSx} title="Not Included" />
                                    </span>
                                );
                            }
                            return null;
                        })()
                    ) : (
                        !hideImg && cell?.img && cell?.img?.map((tempImg, index) => {
                            let imgMargin = "auto";
                            // eslint-disable-next-line eqeqeq
                            if  (type == "thead" && headerTextAlign?.toLowerCase() != "center") {
                                imgMargin = "0px";
                            }
                            // eslint-disable-next-line eqeqeq
                            if  (type == "tbody" && bodyTextAlign?.toLowerCase() != "center") {
                                imgMargin = "0px";
                            }
                            if (imgContainerSx) {
                                return (
                                    <DtvBox key={index} sx={{
 ...imgContainerSx,
margin: imgMargin,
overflow: "hidden",
display: "flex",
alignItems: "center",
justifyContent: "center"
}}>
                                        <CardMedia
                                            alt={tempImg?.altText}
                                            component="img"
                                            src={tempImg?.imgUrl}
                                            sx={{
                                                ...(tempImg?.sx && tempImg?.sx),
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain",
                                                display: "block",
                                                margin: "auto"
                                            }}
                                        />
                                    </DtvBox>
                                );
                            }
                            return (<CardMedia
                                alt={tempImg?.altText}
                                component="img"
                                key={index}
                                src={tempImg?.imgUrl}
                                sx={{
                                    ...(tempImg?.sx && tempImg?.sx),
                                    // eslint-disable-next-line eqeqeq
                                    ...(type == "tbody" && key != 'features1' ? { paddingTop: "10px" } : {}),
                                        margin: imgMargin,
                                    // eslint-disable-next-line eqeqeq
                                    ...(type == "mheader" && {
                                        transform: "rotate(270deg)",
                                        position: "absolute",
                                        left: "-39px"
                                    })
                                }}
                            />)
                        })
                    )}
                    {/* Generated by Copilot- End - 2026-04-21 01:00:40 */}
                    {cell?.title && <DtvText
                        component="div"
                        variant="body2medium"
                        sx={{
                            fontSize: getFontSize('title', type),
                            fontWeight: titleFontWeight ?? "700",
                            padding: "3px",
                            // eslint-disable-next-line eqeqeq
                            ...(type == "mheader" && {
                                '@supports (writing-mode: vertical-rl)': {
                                    writingMode: "vertical-rl",
                                    transform: "rotate(180deg)"
                                }
                            }),
                            // eslint-disable-next-line eqeqeq
                            ...(enableColumnBgColor && section && type == "tbody"  && {
                                color: section?.[index]?.fontColor
                            }),
                            // eslint-disable-next-line eqeqeq
                            ...(enableColumnBgColor && section && type == "thead"  && {
                                color: section?.fontColor
                            })
                        }}
                        {...cell?.title}
                        tooltip={{
                            sx: {
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "tbody"  && {
                                    color: section?.[index]?.fontColor
                                }),
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "thead"  && {
                                    color: section?.fontColor
                                }),
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && (type == "mheader" || type == "header")  && {
                                    color: section?.[index]?.fontColor
                                }),
                                // eslint-disable-next-line eqeqeq
                                ...(type == "mheader" && {
                                    position: "absolute",
                                    top: "auto",
                                    left: "0px",
                                    transform: "rotate(90deg)",
                                    marginTop: "2px"
                                })
                            },
                            content: cell?.title?.tooltip?.content
                        }}
                    />}
                    {cell?.description && <DtvText
                        component="div"
                        sx={{
                            fontSize: getFontSize("description", type),
                            fontWeight: "400",
                            paddingTop: "5px"
                        }}
                        {...cell?.description}

                        tooltip={{
                            sx: {
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "tbody"  && {
                                    color: section?.[index]?.fontColor
                                }),
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "thead"  && {
                                    color: section?.fontColor
                                })
                            },
                            content: cell?.description?.tooltip?.content
                        }}
                    />}
                    {cell?.titleDescription && <DtvText
                        component="div"
                        sx={{
                            fontSize: getFontSize("titleDescription", type),
                            fontWeight: "400",
                            paddingTop: "5px"
                        }}
                        {...cell?.titleDescription}
                        tooltip={{
                            sx: {
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "tbody"  && {
                                    color: section?.[index]?.fontColor
                                }),
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "thead"  && {
                                    color: section?.fontColor
                                })
                            },
                            content: cell?.titleDescription?.tooltip?.content
                        }}
                    />}
                    {cell?.titleCaption && <DtvText
                        component="div"
                        sx={{
                            fontSize: getFontSize("titleCaption", type),
                            fontWeight: "400",
                            paddingTop: "5px"
                        }}
                        {...cell?.titleCaption}
                        tooltip={{
                            sx: {
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "tbody"  && {
                                    color: section?.[index]?.fontColor
                                }),
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "thead"  && {
                                    color: section?.fontColor
                                })
                            },
                            content: cell?.titleCaption?.tooltip?.content
                        }}
                    />}
                    {cell?.tooltip && (
                        <DtvTooltip
                            {...cell?.tooltip}
                            sx={{
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "tbody"  && {
                                    color: section?.[index]?.fontColor
                                }),
                                // eslint-disable-next-line eqeqeq
                                ...(enableColumnBgColor && section && type == "thead"  && {
                                    color: section?.fontColor
                                })
                            }}
                        />
                    )}
                </>
      );
    }
    // eslint-disable-next-line eqeqeq
    const getHeaderData = (product: any, imgContainerSx?: any) => header?.map((val, index) => (val?.category == product?.category ? getContent(val, '', 'mheader', index, headerSectionBgColor, { imgContainerSx }) : ''))
    // const headerData = header?.filter(val => val?.category == product?.category)?.[0];
    // console.log('headerData -> ', headerData);
    // return headerData ? getContent(headerData, '', 'mheader', 0, null) : '';

    const headerFeature = features?.[0];
    const bodyFeatures = features?.slice(1);
    return (
            <>
                <DtvBox
                    id="desktop-view"
                    sx={{
                        display: {
                            lg: "block",
                            xl: "block",
                            md: "block",
                            xs: "none",
                            sm: "none"
                        }
                    }}
                >
                    <TableContainer component={Paper} elevation={2} sx={{ overflow: 'hidden' }}>
                        <Table aria-label={isComparisonTable ? "comparison table" : "schedule table"} sx={{
 border: '1px solid #D1D1D1',
borderBottom: 0,
borderCollapse: "separate",
borderSpacing: 0
}}>
                            <TableHead>
                                {/* Generated by Copilot- Start - 2026-05-06 00:56:18 */}
                                {isComparisonTable ? (
                                <>
                                {/* Row 1: single colSpan DIRECTV brand cell → one continuous top border */}
                                <TableRow>
                                            <TableCell rowSpan={2} sx={{
 padding: 0,
backgroundColor: `${sectionBgColor?.section1 ?? ""}`
}} />
                                            <TableCell
                                                colSpan={directvProducts?.length ?? 1}
                                                component="th"
                                                scope="col"
                                                sx={{
                                                    padding: "8px 5px",
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                    backgroundColor: `${sectionBgColor?.section2 ?? "#FBFBFB"}`,
                                                    borderTopWidth: "5px",
                                                    borderLeftWidth: "5px",
                                                    borderRightWidth: "5px",
                                                    borderBottomWidth: "0",
                                                    borderStyle: "solid",
                                                    borderImage: GRADIENT_BORDER,
                                                    ...(enableColumnBgColor && {
                                                        backgroundColor: headerSectionBgColor?.[1]?.color,
                                                        color: headerSectionBgColor?.[1]?.fontColor
                                                    })
                                                }}
                                            >
                                                {directvHeader && getContent(directvHeader, '', 'header', 0, null, {})}
                                            </TableCell>
                                            {/* Competitor cells span both header rows */}
                                            {competitorProducts?.map((product, cIdx) => (
                                                <TableCell
                                                    component="th"
                                                    key={`comp-header-${cIdx}`}
                                                    rowSpan={2}
                                                    scope="col"
                                                    sx={{
                                                        padding: "8px 5px",
                                                        textAlign: "center",
                                                        verticalAlign: "middle",
                                                        borderRight: "1px solid #D1D1D1",
                                                        backgroundColor: `${sectionBgColor?.section3 ?? ""}`,
                                                        ...(enableColumnBgColor && {
                                                            backgroundColor: `${section3ColBgColor?.[cIdx]?.color} !important`,
                                                            color: `${section3ColBgColor?.[cIdx]?.fontColor} !important`
                                                        })
                                                    }}
                                                >
                                                    {headerFeature?.mapKey && product?.values[headerFeature.mapKey] && getContent(product.values[headerFeature.mapKey], headerFeature.mapKey, "thead", cIdx, section3ColBgColor, {
 imgContainerSx: {
 width: "117px",
height: "70px"
}
})}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                        {/* Row 2: individual product identity cells, left/right border only */}
                                        <TableRow>
                                            {directvProducts?.map((product, productIndex) => (
                                                <TableCell
                                                    component="th"
                                                    key={`dtv-product-identity-${productIndex}`}
                                                    scope="col"
                                                    sx={{
                                                        padding: "8px 5px",
                                                        textAlign: "center",
                                                        verticalAlign: "middle",
                                                        backgroundColor: `${sectionBgColor?.section2 ?? "#FBFBFB"}`,
                                                        borderTopWidth: "0",
                                                        borderLeftWidth: productIndex === 0 ? "5px" : "0",
                                                        borderRightWidth: productIndex === (directvProducts?.length ?? 1) - 1 ? "5px" : "0",
                                                        borderBottomWidth: "0",
                                                        borderStyle: "solid",
                                                        borderImage: GRADIENT_BORDER,
                                                        ...(productIndex > 0 && { boxShadow: "inset 1px 0 0 #D1D1D1" }),
                                                        ...(enableColumnBgColor && {
                                                            backgroundColor: headerSectionBgColor?.[1]?.color,
                                                            color: headerSectionBgColor?.[1]?.fontColor
                                                        })
                                                    }}
                                                >
                                                    {headerFeature?.mapKey && product?.values[headerFeature.mapKey] && getContent(product.values[headerFeature.mapKey], headerFeature.mapKey, "thead", productIndex, section2ColBgColor, { hideImg: true })}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                </>
                                ) : (
                                /* Simple single-row header for plain tables (no gradient border) */
                                <TableRow>
                                    <TableCell
                                        component="th"
                                        scope="col"
                                        sx={{
                                            padding: "8px 16px",
                                            textAlign: `${headerTextAlign ? headerTextAlign : "center"}`,
                                            verticalAlign: "middle",
                                            fontWeight: "700",
                                            backgroundColor: `${sectionBgColor?.section1 ?? ""}`,
                                            borderBottom: "1px solid #D1D1D1"
                                        }}
                                    >
                                        {header?.[0] && getContent(header[0], '', 'thead', 0, section1ColBgColor, { titleFontWeight: "700" })}
                                    </TableCell>
                                    {directvProducts?.map((_, productIndex) => (
                                        <TableCell
                                            component="th"
                                            key={`dtv-plain-header-${productIndex}`}
                                            scope="col"
                                            sx={{
                                                padding: "8px 16px",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                                backgroundColor: `${sectionBgColor?.section2 ?? "#FBFBFB"}`,
                                                borderLeft: "1px solid #D1D1D1",
                                                borderBottom: "1px solid #D1D1D1"
                                            }}
                                        >
                                            {header?.[1 + productIndex] && getContent(header[1 + productIndex], '', 'thead', productIndex, section2ColBgColor, { titleFontWeight: "700" })}
                                        </TableCell>
                                    ))}
                                    {competitorProducts?.map((_, cIdx) => (
                                        <TableCell
                                            component="th"
                                            key={`comp-plain-header-${cIdx}`}
                                            scope="col"
                                            sx={{
                                                padding: "8px 16px",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                                backgroundColor: `${sectionBgColor?.section3 ?? ""}`,
                                                borderLeft: "1px solid #D1D1D1",
                                                borderBottom: "1px solid #D1D1D1",
                                                borderRight: "1px solid #D1D1D1"
                                            }}
                                        >
                                            {header?.[1 + (directvProducts?.length ?? 0) + cIdx] && getContent(header[1 + (directvProducts?.length ?? 0) + cIdx], '', 'thead', cIdx, section3ColBgColor, { titleFontWeight: "700" })}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                )}
                                {/* Generated by Copilot- End - 2026-05-06 00:56:18 */}
                            </TableHead>
                            <TableBody sx={{ "& tr:last-child > td, & tr:last-child > th": { borderBottom: 0 } }}>
                                        {/* In plain-table mode (isComparisonTable=false), raw `features` is used directly as body rows since
                            there is no header-row feature to skip — all features are shown as body content. */}
                        {(isComparisonTable ? bodyFeatures : features)?.map((feature, index) => (
                                            <TableRow key={`feature-${index}`} >
                                                <TableCell
                                                    scope="col"
                                                    sx={{
                                                        padding: "24px 16px",
                                                        height: tableBodyRowHeight ?? "120px",
                                                        width: "168px",
                                                        backgroundColor: `${sectionBgColor?.section1}`,
                                                        textAlign: ` ${headerTextAlign ? headerTextAlign : "center"}`,
                                                        verticalAlign: 'middle',
                                                        ...(enableColumnBgColor && {
                                                            backgroundColor: `${section1ColBgColor?.color} !important`,
                                                            color: `${section1ColBgColor?.fontColor} !important`
                                                        })
                                                    }}
                                                >
                                                    {getContent(feature, '', 'thead', index, section1ColBgColor, { titleFontWeight: "500" })}
                                                </TableCell>

                                                {/* DIRECTV product values */}
                                                {/* Generated by Copilot- Start - 2026-04-21 01:24:18 */}
                                                {directvProducts && directvProducts?.map((product, productIndex) => (
                                                    <TableCell
                                                        key={`${product?.name}-${feature?.mapKey}`}
                                                        scope="row"
                                                        sx={{
                                                            padding: "24px 16px",
                                                            height: tableBodyRowHeight ?? "120px",
                                                            width: "168px",
                                                            textAlign: ` ${bodyTextAlign ? bodyTextAlign : "center"}`,
                                                            verticalAlign: 'middle',
                                                            flexDirection: "column",
                                                            justifyContent: "flex-end",
                                                            backgroundColor: `${sectionBgColor?.section2 || "#FBFBFB"}`,
                                                            position: "relative",
                                                            ...(isComparisonTable ? {
                                                                borderWidth: `0 ${productIndex === (directvProducts?.length ?? 1) - 1 ? "5px" : "0"} 0 ${productIndex === 0 ? "5px" : "0"}`,
                                                                borderStyle: "solid",
                                                                borderImage: GRADIENT_BORDER
                                                            } : {}),
                                                            ...(productIndex > 0 && { boxShadow: "inset 1px 0 0 #D1D1D1" }),
                                                            "&:not(:first-of-type)::before": {
                                                                content: '""',
                                                                position: "absolute",
                                                                top: "-1px",
                                                                left: 0,
                                                                right: 0,
                                                                height: "0.7px",
                                                                background: "#D1D1D1",
                                                                opacity: 0.6,
                                                                pointerEvents: "none"
                                                            },
                                                            ...(enableColumnBgColor && {
                                                                backgroundColor: `${section2ColBgColor?.[productIndex]?.color} !important`,
                                                                color: `${section2ColBgColor?.[productIndex]?.fontColor} !important`
                                                            })
                                                        }}
                                                    >
                                                        {
                                                            (product?.values[feature?.mapKey] && Object.keys(product.values[feature.mapKey]).length > 0) ?
                                                                getContent(product.values[feature.mapKey], feature?.mapKey, "tbody", productIndex, section2ColBgColor, { isDirectv: true }) :
                                                                ''
                                                        }
                                                    </TableCell>
                                                ))}
                                                {/* Generated by Copilot- End - 2026-04-21 01:24:18 */}

                                                {/* Competitors product values */}
                                                {competitorProducts && competitorProducts?.map((product, index) => (
                                                    <TableCell
                                                        key={`${product?.name}-${feature?.mapKey}`}
                                                        sx={{
                                                            padding: "24px 16px",
                                                            height: tableBodyRowHeight ?? "120px",
                                                            width: "168px",
                                                            textAlign: ` ${bodyTextAlign ? bodyTextAlign : "center"}`,
                                                            verticalAlign: 'middle',
                                                            borderRight: '1px solid #D1D1D1',
                                                            backgroundColor: `${sectionBgColor?.section3}`,
                                                            ...(enableColumnBgColor && {
                                                                backgroundColor: `${section3ColBgColor?.[index]?.color} !important`,
                                                                color: `${section3ColBgColor?.[index]?.fontColor} !important`
                                                            })
                                                        }}
                                                    >
                                                        {getContent(product?.values[feature?.mapKey], feature?.mapKey, "tbody", index, section3ColBgColor, {
 imgContainerSx: {
 width: "117px",
height: "70px"
}
})}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                            </TableBody>
                            {/* Footer: single colSpan cell draws one continuous gradient bottom border — mirrors the header approach */}
                            <TableFooter>
                                <TableRow>
                                    <TableCell sx={{
 padding: 0,
height: 0,
borderTopWidth: 0,
borderLeftWidth: 0,
borderRightWidth: 0,
borderBottomWidth: "1px",
borderStyle: "solid",
borderColor: "#D1D1D1",
backgroundColor: `${sectionBgColor?.section1 ?? ""}`
}} />
                                    <TableCell
                                        colSpan={directvProducts?.length ?? 1}
                                        sx={{
                                            padding: 0,
                                            height: 0,
                                            backgroundColor: `${sectionBgColor?.section2 ?? "#FBFBFB"}`,
                                            ...(isComparisonTable ? {
                                                borderTopWidth: "0",
                                                borderLeftWidth: "5px",
                                                borderRightWidth: "5px",
                                                borderBottomWidth: "5px",
                                                borderStyle: "solid",
                                                borderImage: GRADIENT_BORDER
                                            } : {})
                                        }}
                                    />
                                    {competitorProducts?.map((_, i) => (
                                        <TableCell key={`footer-comp-${i}`} sx={{
 padding: 0,
height: 0,
borderTopWidth: 0,
borderLeftWidth: "1px",
borderRightWidth: "1px",
borderBottomWidth: "1px",
borderStyle: "solid",
borderColor: "#D1D1D1"
}} />
                                    ))}
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </DtvBox>

                <DtvBox
                    id="mobile-view"
                    sx={{
                        display: {
                            md: "none",
                            lg: "none",
                            xl: "none",
                            xs: "block",
                            sm: "block"
                        }
                    }}
                >
                    {/* Generated by Copilot- Start - 2026-04-07 19:51:17 */}
                    <TableContainer component={Paper} elevation={2}
                        sx={{
                            overflowX: "auto",
                            overflowY: "hidden",
                            WebkitOverflowScrolling: "touch"
                        }}
                    >
                        <Table
                            aria-label="Comparison Table"
                            sx={{
                                borderCollapse: "separate",
                                width: "100%"
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{
                                            height: isComparisonTable ? "110px" : "auto",
                                            position: "sticky",
                                            left: 0,
                                            zIndex: 3,
                                            backgroundColor: `${sectionBgColor?.section1 || "#ffffff"}`,
                                            border: '1px solid #D1D1D1',
                                            maxWidth: (directvProducts?.length ?? 0) === 1 ? `120px` : `26px`,
                                            minWidth: (directvProducts?.length ?? 0) === 1 ? '120px !important' : '26px !important',
                                            width: (directvProducts?.length ?? 0) === 1 ? '120px' : '26px',
                                            '&.MuiTableCell-root': { padding: '2px' },
                                            ...(enableColumnBgColor && {
                                                backgroundColor: headerSectionBgColor?.[0]?.color ?  headerSectionBgColor?.[0]?.color : "#ffffff",
                                                color: headerSectionBgColor?.[0]?.fontColor ? headerSectionBgColor?.[0]?.fontColor : "#000000"
                                            })
                                        }}
                                    >
                                    </TableCell>
                                    {features && features?.map((feature, index) => {
                                        // For single genre pack (gradient border mode), skip features[0] in header — it's shown in the sticky left body cell
                                        if (isComparisonTable && (directvProducts?.length ?? 0) === 1 && index === 0) {
 return null;
}
                                        const stickyLeft = (directvProducts?.length ?? 0) === 1 ? '120px' : '26px';
                                        return (
                                        <TableCell
                                            key={`feature-${index}`}
                                            sx={{
                                                padding: "24px 16px",
                                                height: mobileTableBodyRowHeight ?? "135px",
                                                textAlign: ` ${headerTextAlign ? headerTextAlign : "center"}`,
                                                verticalAlign: 'middle',
                                                backgroundColor: `${sectionBgColor?.section1 || "#ffffff"} !important`,
                                                ...((isComparisonTable && index === 0) ? {
                                                    position: "sticky",
                                                    left: stickyLeft,
                                                    zIndex: 2
                                                } : {}),
                                                ...(enableColumnBgColor && {
                                                    backgroundColor: `${section1ColBgColor?.color || "#ffffff"} !important`,
                                                    color: `${section1ColBgColor?.fontColor} !important`
                                                }),
                                                border: '1px solid #D1D1D1'
                                            }}
                                        >
                                            {getContent(feature, '', 'thead', index, section1ColBgColor, {
 titleFontWeight: "500",
hideImg: index === 0
})}
                                        </TableCell>
                                        );
                                    })}
                                    {/* Trailing cell to align with DIRECTV right-border rowspan column */}
                                    <TableCell sx={{
 padding: 0,
width: 0,
maxWidth: 0,
minWidth: 0,
border: 0,
overflow: "hidden"
}} />
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {/* DIRECTV Products */}
                                {directvProducts?.map((product, index) => (
                                    <TableRow
                                        key={product.name}
                                    >
                                        {/* Generated by Copilot- Start - 2026-04-21 01:24:18 */}
                                        {(!isComparisonTable || index === 0) && (
                                            <TableCell
                                                rowSpan={isComparisonTable ? directvProducts?.length : 1}
                                                sx={{
                                                    textAlign: "center",
                                                    verticalAlign: 'middle',
                                                    position: "sticky",
                                                    left: 0,
                                                    zIndex: 1,
                                                    '&.MuiTableCell-root': { padding: (directvProducts?.length ?? 0) === 1 ? '8px' : '2px' },
                                                    backgroundColor: `${sectionBgColor?.section2 || "#FBFBFB"} !important`,
                                                    maxWidth: (directvProducts?.length ?? 0) === 1 ? "100%" : "26px",
                                                    minWidth: (directvProducts?.length ?? 0) === 1 ? "120px !important" : "26px !important",
                                                    width: (directvProducts?.length ?? 0) === 1 ? "120px" : "26px",
                                                    ...(isComparisonTable ? {
                                                        borderWidth: "5px 0 5px 5px",
                                                        borderStyle: "solid",
                                                        borderImage: GRADIENT_BORDER_VERTICAL
                                                    } : {}),
                                                    boxShadow: "inset -1px 0 0 #D1D1D1",
                                                    ...(enableColumnBgColor && {
                                                        backgroundColor: headerSectionBgColor?.[1]?.color || "#ffffff",
                                                        color: headerSectionBgColor?.[1]?.fontColor
                                                    })
                                                }}
                                            >
                                                {/* Generated by Copilot- Start - 2026-05-06 01:36:42 */}
                                                {isComparisonTable ? (
                                                    /* Gradient border mode: show product identity (logo/name) */
                                                    (directvProducts?.length ?? 0) === 1 ?
                                                        directvHeader && getContent(directvHeader, '', 'header', 0, null, {}) :
                                                        getHeaderData(product)
                                                ) : (
                                                    /* Plain table mode: show positional header label (e.g. "Dates") */
                                                    header?.[1 + index] && getContent(header[1 + index], '', 'thead', index, section2ColBgColor, { titleFontWeight: "700" })
                                                )}
                                                {isComparisonTable && (directvProducts?.length ?? 0) === 1 && features?.[0]?.mapKey && product?.values[features[0].mapKey] &&
                                                    getContent(product.values[features[0].mapKey], features[0].mapKey, "thead", 0, section2ColBgColor, { hideImg: true })
                                                }
                                                {/* Generated by Copilot- End - 2026-05-06 01:36:42 */}
                                            </TableCell>
                                        )}
                                        {features && features?.map((feature, featureIndex) => {
                                            // For single genre pack (gradient border mode only), skip features[0] — it's already shown in the sticky left cell
                                            if (isComparisonTable && (directvProducts?.length ?? 0) === 1 && featureIndex === 0) {
 return null;
}
                                            return (
                                            <TableCell
                                                key={`${product?.name}-${feature?.mapKey}`}
                                                sx={{
                                                    textAlign: ` ${bodyTextAlign ? bodyTextAlign : "center"}`,
                                                    verticalAlign: 'middle',
                                                    padding: "24px 16px",
                                                    ...((isComparisonTable && featureIndex === 0 && (directvProducts?.length ?? 0) > 1) ? {
                                                        position: "sticky",
                                                        left: '26px',
                                                        zIndex: 1
                                                    } : {}),
                                                    height: mobileTableBodyRowHeight ?? "135px",
                                                    backgroundColor: `${sectionBgColor?.section2 || "#FBFBFB"} !important`,
                                                    ...(isComparisonTable ? {
                                                        borderWidth: `${index === 0 ? "5px" : "0"} 0 ${index === (directvProducts?.length ?? 0) - 1 ? "5px" : "0"} 0`,
                                                        borderStyle: "solid",
                                                        borderImage: GRADIENT_BORDER_VERTICAL
                                                    } : {}),
                                                    boxShadow: [
                                                        "inset 1px 0 0 #D1D1D1",
                                                        "inset -1px 0 0 #D1D1D1",
                                                        index !== 0 ? "inset 0 1px 0 #D1D1D1" : null,
                                                        index !== (directvProducts?.length ?? 0) - 1 ? "inset 0 -1px 0 #D1D1D1" : null
                                                    ].filter(Boolean).join(", "),
                                                    ...(enableColumnBgColor && {
                                                        backgroundColor: `${section2ColBgColor?.[index]?.color || "#ffffff"} !important`,
                                                        color: `${section2ColBgColor?.[index]?.fontColor} !important`
                                                    })
                                                }}
                                            >
                                                {
                                                    (product?.values[feature?.mapKey] && Object.keys(product.values[feature.mapKey]).length > 0) ?
                                                        getContent(product.values[feature.mapKey], feature?.mapKey, "tbody", index, section2ColBgColor, {
 isDirectv: true,
hideImg: isComparisonTable && featureIndex === 0
}) :
                                                        ''
                                                }
                                            </TableCell>
                                            );
                                        })}                                        {/* Right-border rowspan cell: spans all DIRECTV rows for one continuous gradient */}
                                        {index === 0 && (
                                            <TableCell
                                                rowSpan={directvProducts?.length}
                                                sx={{
                                                    padding: 0,
                                                    width: 0,
                                                    maxWidth: 0,
                                                    minWidth: 0,
                                                    overflow: "hidden",
                                                    backgroundColor: `${sectionBgColor?.section2 || "#FBFBFB"}`,
                                                    ...(isComparisonTable ? {
                                                        borderTopWidth: "5px",
                                                        borderRightWidth: "5px",
                                                        borderBottomWidth: "5px",
                                                        borderLeftWidth: 0,
                                                        borderStyle: "solid",
                                                        borderImage: GRADIENT_BORDER_VERTICAL
                                                    } : {})
                                                }}
                                            />
                                        )}
                                        {/* Generated by Copilot- End - 2026-04-21 01:24:18 */}
                                    </TableRow>
                                ))}

                                {/* Competitor Products */}
                                {competitorProducts && competitorProducts?.map((product, index) => {
                                    const isSingleGenrePack = (directvProducts?.length ?? 0) === 1;
                                    return (
                                        <TableRow key={product?.name} >
                                            {/* Single genre pack: each competitor row has its own sticky cell. Multiple: one rowSpan cell */}
                                            {(!isComparisonTable || isSingleGenrePack || index === 0) && (
                                                <TableCell
                                                    rowSpan={isComparisonTable ? (isSingleGenrePack ? 1 : competitorProducts?.length) : 1}
                                                    sx={{
                                                        textAlign: "center",
                                                        verticalAlign: 'middle',
                                                        position: "sticky",
                                                        left: 0,
                                                        zIndex: 1,
                                                        border: '1px solid #D1D1D1',
                                                        backgroundColor: `${sectionBgColor?.section3 || "#ffffff"} !important`,
                                                        '&.MuiTableCell-root': { padding: isSingleGenrePack ? '8px' : '2px' },
                                                        maxWidth: isSingleGenrePack ? "120px" : `26px`,
                                                        minWidth: isSingleGenrePack ? '120px !important' : '26px !important',
                                                        width: isSingleGenrePack ? '120px' : '26px',
                                                        ...(enableColumnBgColor && {
                                                            backgroundColor: headerSectionBgColor?.[2]?.color || "#ffffff",
                                                            color: headerSectionBgColor?.[2]?.fontColor
                                                        })
                                                    }}
                                                >
                                                    {/* Generated by Copilot- Start - 2026-05-06 01:36:42 */}
                                                    {isComparisonTable ? (
                                                        isSingleGenrePack ?
                                                            (features?.[0]?.mapKey && product?.values[features[0].mapKey] &&
                                                                getContent(product.values[features[0].mapKey], features[0].mapKey, "thead", index, section3ColBgColor, {
 imgContainerSx: {
 width: "90px",
height: "28px"
}
})) :
                                                            getHeaderData(product, {
 width: "90px",
height: "28px"
})
                                                    ) : (
                                                        /* Plain table mode: show positional header label (e.g. "Channels on DIRECTV") */
                                                        header?.[1 + (directvProducts?.length ?? 0) + index] &&
                                                            getContent(header[1 + (directvProducts?.length ?? 0) + index], '', 'thead', index, section3ColBgColor, { titleFontWeight: "700" })
                                                    )}
                                                    {/* Generated by Copilot- End - 2026-05-06 01:36:42 */}
                                                </TableCell>
                                            )}
                                            {features && features?.map((feature, featureIndex) => {
                                                // For single genre pack (gradient border mode only), skip features[0] — product identity is in sticky cell
                                                if (isComparisonTable && isSingleGenrePack && featureIndex === 0) {
 return null;
}
                                                const isStickyCol = isComparisonTable && featureIndex === 0 && !isSingleGenrePack;
                                                return (
                                                <TableCell
                                                    key={`${product?.name}-${feature?.mapKey}`}
                                                    sx={{
                                                        textAlign: ` ${bodyTextAlign ? bodyTextAlign : "center"}`,
                                                        verticalAlign: 'middle',
                                                        padding: "24px 16px",
                                                        ...(isStickyCol ? {
                                                            position: "sticky",
                                                            left: isSingleGenrePack ? '120px' : '26px',
                                                            zIndex: 1
                                                        } : {}),
                                                        border: '1px solid #D1D1D1',
                                                        height: mobileTableBodyRowHeight ?? "135px",
                                                        backgroundColor: `${sectionBgColor?.section3 || "#ffffff"} !important`,
                                                        ...(enableColumnBgColor && {
                                                            backgroundColor: `${section3ColBgColor?.[index]?.color || "#ffffff"} !important`,
                                                            color: `${section3ColBgColor?.[index]?.fontColor} !important`
                                                        })
                                                    }}
                                                >
                                                        {getContent(product?.values[feature?.mapKey], feature?.mapKey, "tbody", index, section3ColBgColor, {
                                                            imgContainerSx: {
                                                                width: "90px",
                                                                height: "28px"
                                                            }
                                                        })}
                                                </TableCell>
                                                );
                                            })}
                                            {/* Trailing cell to align with DIRECTV right-border column */}
                                            <TableCell sx={{
 padding: 0,
width: 0,
maxWidth: 0,
minWidth: 0,
border: 0,
overflow: "hidden"
}} />
                                        </TableRow>
                                    )
})}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* Generated by Copilot- End - 2026-04-07 19:51:17 */}
                </DtvBox>
            </>
    );
  } catch (error) {
    return <ErrorDisplay component="DtvCompetitorTable" error={error} />;
  }
}
